import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { formatDisplayDate } from '@/utils/date';
import { formatNumber } from '@/utils/number';
import { DECISION_LABEL } from '../constants/marketPromotion.constants';
import type { MpApprovalRow } from '../types/marketPromotion.types';

interface ViewDonationDialogProps {
  donation: MpApprovalRow | null;
  onOpenChange: (open: boolean) => void;
}

const dash = (value: string | number | null | undefined): string =>
  value === null || value === undefined || value === '' ? '—' : String(value);

export function ViewDonationDialog({ donation, onOpenChange }: ViewDonationDialogProps) {
  return (
    <Dialog open={donation !== null} onOpenChange={onOpenChange}>
      <DialogContent className="max-h-[85vh] overflow-auto sm:max-w-2xl">
        {donation === null ? null : (
          <>
            <DialogHeader>
              <DialogTitle>{donation.itemName}</DialogTitle>
              <DialogDescription>
                {formatDisplayDate(donation.dcrDate)} ·{' '}
                {DECISION_LABEL[donation.approveTypeNo] ?? '—'}
              </DialogDescription>
            </DialogHeader>

            <dl className="grid grid-cols-2 gap-x-6 gap-y-3 text-sm">
              <Row label="Claimed" value={`${formatNumber(donation.claimedAmount)} Tk`} />
              <Row label="Approved" value={`${formatNumber(donation.approvedAmount)} Tk`} />
              <Row label="Institute" value={dash(donation.instituteName)} />
              <Row label="EIIN" value={dash(donation.instituteEiin)} />
              <Row label="Thana" value={dash(donation.instituteThana)} />
              <Row label="District" value={dash(donation.instituteDistrict)} />
              <Row label="Teacher" value={dash(donation.teacherName)} />
              <Row label="Teacher Mobile" value={dash(donation.teacherMobile)} />
              <Row label="Given By" value={dash(donation.enteredByName)} />
              <Row label="Given By Mobile" value={dash(donation.enteredByMobile)} />
              <Row label="Payment Type" value={dash(donation.paymentType)} />
              <Row label="Payment Place" value={dash(donation.paymentPlace)} />
              <Row label="Given Date" value={formatDisplayDate(donation.givenDate)} />
              <Row label="Transaction Ref" value={dash(donation.transactionRef)} />
              <Row label="Witness" value={dash(donation.witness)} />
              <Row label="Students" value={dash(donation.totalStudent)} />
              <Row label="Recommended By" value={dash(donation.recommendedBy)} />
              <Row label="Recommendation" value={dash(donation.recommendedComments)} />
              <Row label="Approval Comment" value={dash(donation.approvalComments)} />
              <Row label="Paperwork" value={donation.hasAttachment ? 'On file' : 'None'} />
              <Row label="Called By" value={dash(donation.calledBy)} />
              <Row label="MIS Verified" value={donation.isMisVerified ? 'Yes' : 'No'} />
            </dl>
          </>
        )}
      </DialogContent>
    </Dialog>
  );
}

function Row({ label, value }: { label: string; value: string }) {
  return (
    <div className="flex flex-col">
      <dt className="text-xs uppercase tracking-wide text-muted-foreground">{label}</dt>
      <dd className="mt-0.5">{value}</dd>
    </div>
  );
}
